<template>
  <div
    class="modal fade"
    data-bs-backdrop="static"
    tabindex="-1"
    ref="modalDetail"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title"
            id="exampleModalLabel"
            style="padding-left: 5px; padding-right: 10px"
          >
            {{ numeric }}
          </h5>
          <div>
            <div style="font-weight: bold; text-transform: uppercase">
              {{ titleDetail }}
            </div>
            <!-- <div style="font-size: 12px; font-weight: 500">
              Last Updated: {{ lastUpdate }}
            </div> -->
          </div>
          <div
            class="position-inherit card-header-right"
            style="position: absolute; right: 50px"
          >
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col-5" style="text-align: center">
                    <span style="color: #9f9f9f">Polarity</span>
                  </div>
                  <div class="modal-contract col-7" style="text-align: center">
                    <span style="color: #9f9f9f">Achievement</span>
                  </div>
                </div>
                <div class="row prod-mobile">
                  <!--                                    <div class="col"></div>-->
                  <!-- <div class="col" style="font-weight: 500; color: #9f9f9f">
                    Polarity
                  </div> -->
                  <div class="col-2" style="font-weight: 500; display: flex">
                    <img
                      src="@/assets/images/caret_up.svg"
                      style="width: 30%"
                    />
                    Positf
                    <img
                      src="@/assets/images/caret_down.svg"
                      style="margin-left: 10px; width: 30%"
                    />Negatif<i class="bi bi-caret-up-fill"></i>
                  </div>
                  <!-- <div class="col" style="font-weight: 500; display: flex">
                  </div> -->
                  <div style="text-align: right" class="col-10">
                    <span class="badge rounded-pill bg-danger">< 95%</span>
                    <span class="badge rounded-pill bg-warning">95-99%</span>
                    <span class="badge rounded-pill bg-success">>=100%</span>
                    <span
                      style="background-color: #818181"
                      class="badge rounded-pill text-white"
                      >Not Started</span
                    >
                  </div>
                  <!-- <div class="col">
                    <span class="badge rounded-pill bg-warning text-dark"
                      >95-99%</span
                    >
                  </div>
                  <div class="col">
                    <span class="badge rounded-pill bg-success">>=100%</span>
                  </div>
                  <div class="col">
                    <span
                      style="background-color: #818181"
                      class="badge rounded-pill text-white"
                      >Not Started</span
                    >
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body thermal-mobile">
          <table class="table">
            <thead>
              <tr>
                <th style="font-size: smaller; color: #5f5f5f" scope="col">
                  No.
                </th>
                <th
                  scope="col"
                  style="font-size: smaller; width: 400px; color: #5f5f5f"
                >
                  Key Performance Indicator
                </th>
                <th scope="col" style="font-size: smaller; color: #5f5f5f">
                  Polarity
                </th>
                <th scope="col" style="font-size: smaller; color: #5f5f5f">
                  Weight
                </th>
                <th scope="col" style="font-size: smaller; color: #5f5f5f">
                  Unit
                </th>
                <th scope="col" style="font-size: smaller; color: #5f5f5f">
                  2024 Target
                </th>
                <th scope="col" style="font-size: smaller; color: #5f5f5f">
                  YTD Target
                </th>
                <th scope="col" style="font-size: smaller; color: #5f5f5f">
                  YTD Realization
                </th>
                <th scope="col" style="font-size: smaller; color: #5f5f5f">
                  Achievement (%)
                </th>
                <th scope="col" style="font-size: smaller; color: #5f5f5f">
                  Value
                </th>
                <th scope="col" style="font-size: smaller; color: #5f5f5f"></th>
              </tr>
            </thead>
            <tbody v-for="(item, id) in dataDetail" :key="id">
              <tr
                v-if="
                  item.weight === null &&
                  item.achievement === null &&
                  item.numberId === ''
                "
              >
                <th style="background-color: #f6faff"></th>
                <td colspan="12" style="background-color: #f6faff">
                  {{ item.metricName }}
                </td>
              </tr>
              <tr v-if="item.numberId !== '' && item.metricId !== 'OVERALL'">
                <th>{{ item.numberId }}</th>
                <td>{{ item.metricName }}</td>
                <td>
                  <img
                    v-if="item.polarity === 'max'"
                    src="@/assets/images/caret_up.svg"
                    style="margin-right: 5px"
                  />
                  <img
                    v-else
                    src="@/assets/images/caret_down.svg"
                    style="margin-right: 5px"
                  />
                </td>
                <td>{{ item.weight }}</td>
                <td>{{ item.unit }}</td>
                <td>{{ item.valueTarget }}</td>
                <td>{{ item.ytdTarget }}</td>
                <td>{{ item.ytdRealization }}</td>
                <td>{{ item.achievement }}</td>
                <td>{{ item.value }}</td>
                <td v-if="item.color === '#54BA4A'">
                  <img src="@/assets/images/green_o.svg" />
                </td>
                <td v-if="item.color === '#FF0000'">
                  <img src="@/assets/images/red_o.svg" />
                </td>
                <td v-if="item.color === '#CDCDCD'">
                  <img src="@/assets/images/grey_o.svg" />
                </td>
                <td v-if="item.color === '#FF9900'">
                  <img src="@/assets/images/orange_o.svg" />
                </td>
              </tr>
              <tr
                v-if="
                  item.achievement === null &&
                  item.weight !== null &&
                  item.metricId === 'OVERALL'
                "
              >
                <td
                  colspan="3"
                  style="background-color: #d1dfe5; font-weight: bold"
                >
                  Overall
                </td>
                <td
                  colspan="6"
                  style="background-color: #d1dfe5; font-weight: bold"
                >
                  {{ item.weight }}
                </td>
                <td
                  colspan="2"
                  style="font-weight: bold; background-color: #d1dfe5"
                >
                  {{ item.value }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--                          <div class="modal-footer">-->
        <!--                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>-->
        <!--                            <button type="button" class="btn btn-primary">Save changes</button>-->
        <!--                          </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import IconSvg from "@/components/IconSvg.vue";
import ManagementContract from "@/services/management-contract/management-contract";

const apiContract = ManagementContract.build();
export default {
  props: ["showModal", "datas", "titleDetail", "numeric"],
  components: {
    IconSvg,
  },
  data() {
    return {
      lastUpdate: "",
      modal: null,
      dataDetail: [],
    };
  },

  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modalDetail);
  },

  watch: {
    showModal() {
      if (this.showModal) {
        this.getDataSummaryDetail();
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
  },
  methods: {
    async getDataSummaryDetail() {
      const param = {
        parentId: this.datas,
      };
      const res = await apiContract.getDataSummaryContractDetail(param);
      this.lastUpdate = res.data.lastUpdate;
      const data = res.data.data;
      this.dataDetail = data;
    },
    closeModal() {
      this.$emit("closeModal", false);
    },
  },
};
</script>
